import { render } from "./EanCodesGroup.vue?vue&type=template&id=cc22a556"
import script from "./EanCodesGroup.vue?vue&type=script&lang=js"
export * from "./EanCodesGroup.vue?vue&type=script&lang=js"

import "./EanCodesGroup.vue?vue&type=style&index=0&id=cc22a556&lang=scss"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__